export enum ConfigurationFields {
    Meta = 'meta',
    Flows = 'flows',
    BlockDefinitions = 'blockDefinitions',
    Customization = 'customization',
    UserIds = 'userIds',
    ApplicationSettings = 'applicationSettings',
    Features = 'features',
    UserSettings = 'userSettings'
}
